import { TimelineItemCategoryEnum } from "web_myplann/Infrastructure/Api/Api";

export const CATEGORY_PRIORITY: Record<TimelineItemCategoryEnum, number> = {
	[TimelineItemCategoryEnum.Contract]: 1,
	[TimelineItemCategoryEnum.Activity]: 2,
	[TimelineItemCategoryEnum.Reminder]: 3,
	[TimelineItemCategoryEnum.Task]: 4,
	[TimelineItemCategoryEnum.ClientAction]: 5,
	[TimelineItemCategoryEnum.Notification]: 6,
	[TimelineItemCategoryEnum.IdentificationDocument]: 7,
};
